module.exports = __webpack_public_path__ + "static/media/1_A1_06.9a5a1cde.png";